import axios from '@/axios'

export default {
	createPin(payload, headers) {
		return axios.post(`/active-balance`, payload, headers)
	},
	changePin(payload, headers) {
		return axios.post(`/saldo-pin-change`, payload, headers)
	},
	getBalance(user_id, options) {
		return axios.get(`/saldo-balance/${user_id}`, options)
	}
}